import { OptionType } from "components/select-form-field/select-form-field.component";

export const enum TagTypes {
  PATIENT = "Patient",
  PATIENT_PRODUCT = "PatientProduct",
  INVENTORY_PRODUCT = "InventoryProduct",
  APPOINTMENT = "Appointment",
  SALE = "Sale",
  FAX = "Fax",
  CHART_NOTE = "ChartNote",
  TASK = "Task",
  ERA_CLAIM = "ERAClaim",
  // Attaches to the Patient object (a texting conversation is 1:1 with its
  // patient) but is a separate vocabulary from Patient tags — the inbox shows
  // only Conversation tags and patient surfaces show only Patient tags.
  CONVERSATION = "Conversation",
  // A phone call (dialstack Call) — ENG-2176.
  CALL = "Call",
  // A practice's own SOP / policy document (the SOPs page). The tags are its categories.
  INTERNAL_DOCUMENT = "InternalDocument"
}

export const TagTypeOptions: OptionType[] = [
  { value: "Patient", label: "Patient" },
  { value: "PatientProduct", label: "Patient Devices" },
  { value: "InventoryProduct", label: "Clinic Stock" },
  { value: "Appointment", label: "Appointment" },
  { value: "Sale", label: "Sale" },
  { value: "Fax", label: "Fax" },
  { value: "ChartNote", label: "Chart Note" },
  { value: "Task", label: "Task" },
  { value: "ERAClaim", label: "ERA" },
  { value: "Conversation", label: "Conversation" },
  { value: "Call", label: "Call" },
  { value: "InternalDocument", label: "Internal Documents" }
];

export const AUTOCOMPLETE_PAGE_SIZE = 100;
